import { useVeltClient } from '@veltdev/react';
import React, { useEffect } from 'react'
import './LiveSelectionPage.css';

function LiveSelectionPage() {

    const { client } = useVeltClient();

    useEffect(() => {
        if (!client) return;

        const selectionElement = client.getSelectionElement();
        selectionElement.enableLiveSelection();

    }, [client]);

    return (
        <div id="liveSelectionContainer">
            <p className="boujeeText">Select text or inputs to highlight on other side.</p>
            <form className="live-selection-form">
                <label htmlFor="fname">First name:</label><br />
                <input type="text" id="fname" name="fname" /><br />
                <label htmlFor="lname">Last name:</label><br />
                <input type="text" id="lname" name="lname" /><br /><br />
                {/* terms and conditions */}
                <input type="checkbox" id="terms" name="terms" value="terms" />
                <label htmlFor="terms"> I accept the terms and conditions</label><br /><br />
                <button>Submit</button>
            </form>
        </div>
    )
}

export default LiveSelectionPage;